<form [formGroup]="form" (ngSubmit)="onSubmit()" class="product w-full flex flex-col">
  <div class="tab-content p-6">
    <mat-form-field appearance="outline" floatLabel="always" class="w-full">
      <mat-label>{{ 'WORKSPACES.DETAIL.NAME' | transloco }}</mat-label>
      <input matInput formControlName="name" />
    </mat-form-field>

    <div class="flex justify-between">
      <mat-form-field appearance="outline" floatLabel="always" class="w-1.4/3">
        <mat-label>{{ 'WORKSPACES.DETAIL.DOC_NUMBER' | transloco }}</mat-label>
        <input matInput formControlName="doc_number" />
      </mat-form-field>

      <mat-form-field appearance="outline" floatLabel="always" class="w-1.4/3">
        <mat-label>{{ 'WORKSPACES.DETAIL.DUNS_NUMBER' | transloco }}</mat-label>
        <input matInput formControlName="duns_number" />
      </mat-form-field>
    </div>

    <mat-form-field appearance="outline" floatLabel="always" class="w-full">
      <mat-label>{{ 'WORKSPACES.DETAIL.DESCRIPTION' | transloco }}</mat-label>
      <textarea matInput rows="3" formControlName="description"> </textarea>
    </mat-form-field>

    <mat-form-field appearance="outline" floatLabel="always" class="w-full">
      <mat-label>{{ 'WORKSPACES.DETAIL.ADDRESS' | transloco }}</mat-label>
      <input matInput formControlName="address" />
    </mat-form-field>

    <div class="flex justify-between gap-4">
      <mat-form-field appearance="outline" floatLabel="always" class="w-1/3">
        <mat-label>{{ 'WORKSPACES.DETAIL.CITY' | transloco }}</mat-label>
        <input matInput formControlName="city" />
      </mat-form-field>

      <mat-form-field appearance="outline" floatLabel="always" class="w-1/3">
        <mat-label>{{ 'WORKSPACES.DETAIL.STATE' | transloco }}</mat-label>
        <input matInput formControlName="state" />
      </mat-form-field>

      <mat-form-field appearance="outline" floatLabel="always" class="w-1/3">
        <mat-label>{{ 'WORKSPACES.DETAIL.POST_CODE' | transloco }}</mat-label>
        <input matInput formControlName="post_code" />
      </mat-form-field>
    </div>

    <mat-form-field appearance="outline" floatLabel="always" class="w-full">
      <mat-label>{{ 'WORKSPACES.DETAIL.COUNTRY' | transloco }}</mat-label>
      <input matInput formControlName="country" />
    </mat-form-field>

    <button mat-flat-button color="primary" class="mr-4" [disabled]="form.invalid || form.pristine">
      <span>{{ 'GENERAL.SAVE' | transloco }}</span>
    </button>

    <ng-container>
      <button mat-stroked-button *ifRoles="['keeps_platform_admin']" (click)="onDelete(workspace?.id)">
        <span>{{ 'GENERAL.REMOVE' | transloco }}</span>
      </button>
    </ng-container>
  </div>
</form>
